import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LayoutDashboard, Users, Clapperboard, Film, CreditCard, Scale, Home, Bell } from 'lucide-react';
import PortalShell from '../components/PortalShell';
import { useApp } from '../context/AppContext';

export const ADMIN_NAV = [
  { to: '/admin', label: 'Dashboard', icon: LayoutDashboard, end: true },
  { to: '/admin/users', label: 'Users', icon: Users },
  { to: '/admin/creators', label: 'Creators', icon: Clapperboard },
  { to: '/admin/content', label: 'Content', icon: Film },
  { to: '/admin/homepage', label: 'Homepage', icon: Home },
  { to: '/admin/subscriptions', label: 'Subscriptions', icon: CreditCard },
  { to: '/admin/rights', label: 'Rights & Territories', icon: Scale },
  { to: '/admin/notifications', label: 'Notifications', icon: Bell },
];

export const ACC = '#E72BD4';

export function useAdminGate() {
  const navigate = useNavigate();
  const { user, authLoading, isAdmin } = useApp();
  React.useEffect(() => { if (!authLoading && !user) navigate('/signin'); }, [authLoading, user, navigate]);
  return { user, authLoading, isAdmin, enabled: !!user && isAdmin };
}

export function AdminGate({ children }) {
  const { authLoading, user, isAdmin } = useAdminGate();
  if (authLoading) return <div className="text-[#C7C4CB] text-sm">Loading...</div>;
  if (!user) return null;
  if (!isAdmin) return <div className="surface p-8 text-center" data-testid="admin-denied"><h3 className="font-semibold">Admin access required</h3><p className="text-[13px] text-[#C7C4CB] mt-1">Your account does not have permission to view the Clax Admin portal.</p></div>;
  return children;
}

export const AdminShell = ({ title, actions, children }) => <PortalShell label="Admin" nav={ADMIN_NAV} accent={ACC} title={title} actions={actions}><AdminGate>{children}</AdminGate></PortalShell>;

